<template>
  <div data-qa="price_telemed">
    <div
      class="text-h6 text--text mb-1"
      data-qa="price_telemed_num"
    >
      {{ formattedPrice }}
    </div>
    <div
      class="text-caption text-secondary--text"
      data-qa="price_telemed_desc"
    >
      {{ t('Оплата при записи', options) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { computed } from 'vue'
import { getFormattedPrice } from 'www/utils'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  price?: number | null
  specialitySelected?: boolean
}>()

const hasPrefix = computed(() => !props.specialitySelected)
const formattedPrice = computed(() => (
  getFormattedPrice(props.price, {
    prefix: hasPrefix.value
      ? t('от', options)
      : '',
  })
))
</script>
